(() => {
  const selector = document.querySelector('[data-whiskey-selector]');
  if (!selector) return;

  const choices = {};
  const products = {
    star: {
      title: 'Start with the Star Whiskey Glasses.',
      copy: 'Choose this if you want an easy rocks-glass size for a relaxed pour, light ice, and gifting without overthinking the style.',
      link: '/products/star-crystal-whiskey-glass'
    },
    zeus: {
      title: "Start with Zeus's Stone Whiskey Glasses.",
      copy: 'Choose this if you prefer a more compact glass for neat whiskey, tasting pours, or a deliberate bourbon moment.',
      link: '/products/zeuss-stone-crystal-whiskey-glass'
    },
    eye: {
      title: 'Start with the Eye Whiskey Glasses.',
      copy: 'Choose this if you want more room for cocktails, extra ice, or a glass that feels more visible on a home bar.',
      link: '/products/eye-crystal-whiskey-glass'
    },
    undead: {
      title: 'Start with the Undead Warrior Whiskey Glasses.',
      copy: 'Choose this if you want a balanced rocks-glass size with a bolder design for ice, gifting, and stronger visual presence.',
      link: '/products/undead-warrior-crystal-whiskey-glass'
    }
  };
  const scoreMap = {
    whiskey: { zeus: 3 },
    ice: { star: 3 },
    cocktail: { eye: 3 },
    'no-ice': { zeus: 2 },
    cubes: { star: 2 },
    'large-ice': { undead: 2 },
    compact: { zeus: 3, star: 1 },
    balanced: { undead: 2, star: 2 },
    roomy: { eye: 4 },
    evening: { star: 2 },
    'home-bar': { eye: 2 },
    gift: { undead: 2 }
  };
  const tieBreakers = {
    evening: ['star', 'zeus', 'eye', 'undead'],
    'home-bar': ['eye', 'zeus', 'star', 'undead'],
    gift: ['undead', 'star', 'eye', 'zeus']
  };
  const answer = selector.querySelector('[data-answer]');
  const answerTitle = selector.querySelector('[data-answer-title]');
  const answerCopy = selector.querySelector('[data-answer-copy]');
  const answerLink = selector.querySelector('[data-answer-link]');

  function updateRecommendation() {
    if (!choices.pour || !choices.ice || !choices.capacity || !choices.setting) return;
    const scores = { star: 0, zeus: 0, eye: 0, undead: 0 };
    Object.values(choices).forEach((choice) => {
      if (!scoreMap[choice]) return;
      Object.entries(scoreMap[choice]).forEach(([product, points]) => { scores[product] += points; });
    });
    const highestScore = Math.max(...Object.values(scores));
    const recommendation = tieBreakers[choices.setting].find((product) => scores[product] === highestScore);
    const product = products[recommendation];
    answerTitle.textContent = product.title;
    answerCopy.textContent = product.copy;
    answerLink.href = product.link;
    answerLink.textContent = 'View product details';
    answer.hidden = false;
  }

  selector.querySelectorAll('[data-choice]').forEach((button) => {
    button.addEventListener('click', () => {
      choices[button.dataset.question] = button.dataset.choice;
      updateRecommendation();
    });
  });
})();
